var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-secondary my-5 font-size-14"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.title||'Chưa có dữ liệu'))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }